export default __webpack_public_path__ + "static/blog-05-500x338-dbaa4cd979ff39836ddf603adf0ca6df.jpg";